import React from "react";
import {
  TaxResidencyOverlay,
  UploadDocumentOverlay,
  UploadDocumentOverlayMultiple,
} from "./utils";
import { encryptKycString } from "../../utils/helpers/utils";
import dropdownIcon from "../../assests/page/contact-dropdown.svg";
import arrowUp from "../../assests/page/contact-arrow-up.svg";
import searchIcon from "../../assests/sideBar/search-icon.svg";
import selectBankCircle from "../../assests/page/select-bank-circle.svg";
import selectBankClicked from "../../assests/page/select-bank-clicked.svg";
import useUserStore from "../../store/userSlice";
import { useTranslation } from "react-i18next";

const QuestionaireOverlay = (props) => {
  const { t } = useTranslation();
  const { userAddress } = useUserStore();

  const {
    formStates: {
      _setKycQuestionaire,
      selectedCountry,
      setSelectedCountry,
      selectedCountrySec,
      setSelectedCountrySec,
      selectedCountryInc,
      setSelectedCountryInc,
      searchActive,
      setSearchActive,
      newSearchContent,
      setNewSearchContent,
      countryList,
      setCountryList,
      isCheckboxClicked,
      setIsCheckboxClicked,
      selectedTin,
      setSelectedTin,
      inputTin,
      setInputTin,
      selectedNoTin,
      setSelectedNoTin,
      selectedOtherTax,
      setSelectedOtherTax,
      selectedNoTinSec,
      setSelectedNoTinSec,
      inputNoTin,
      setInputNoTin,
      inputNoTinSec,
      setInputNoTinSec,
      uploadedDocumentW8,
      setUploadedDocumentW8,
      uploadedDocumentHashW8,
      setUploadedDocumentHashW8,
      uploadPercentageW8,
      setUploadPercentageW8,
      uploadedDocumentUBOSource,
      setUploadedDocumentUBOSource,
      uploadedDocumentHashUBOSource,
      setUploadedDocumentHashUBOSource,
      uploadPercentageUBOSource,
      setUploadPercentageUBOSource,
      uploadedDocumentUBO,
      setUploadedDocumentUBO,
      uploadedDocumentHashUBO,
      setUploadedDocumentHashUBO,
      uploadPercentageUBO,
      setUploadPercentageUBO,
      uploadedDocumentProofOfRegulation,
      setUploadedDocumentProofOfRegulation,
      uploadedDocumentHashProofOfRegulation,
      setUploadedDocumentHashProofOfRegulation,
      uploadPercentageProofOfRegulation,
      setUploadPercentageProofOfRegulation,
      uploadedDocumentArticlesOfAssociation,
      setUploadedDocumentArticlesOfAssociation,
      uploadedDocumentHashArticlesOfAssociation,
      setUploadedDocumentHashArticlesOfAssociation,
      uploadPercentageArticlesOfAssociation,
      setUploadPercentageArticlesOfAssociation,
      uploadedDocumentOwnerShipAndCSChart,
      setUploadedDocumentOwnerShipAndCSChart,
      uploadedDocumentHashOwnerShipAndCSChart,
      setUploadedDocumentHashOwnerShipAndCSChart,
      uploadPercentageOwnerShipAndCSChart,
      setUploadPercentageOwnerShipAndCSChart,
      uploadedDocumentRegisterOfDirectors,
      setUploadedDocumentRegisterOfDirectors,
      uploadedDocumentHashRegisterOfDirectors,
      setUploadedDocumentHashRegisterOfDirectors,
      uploadPercentageRegisterOfDirectors,
      setUploadPercentageRegisterOfDirectors,
      uploadedDocumentSignatoryList,
      setUploadedDocumentSignatoryList,
      uploadedDocumentHashSignatoryList,
      setUploadedDocumentHashSignatoryList,
      uploadPercentageSignatoryList,
      setUploadPercentageSignatoryList,
      uploadedDocumentIdOfDirectors,
      setUploadedDocumentIdOfDirectors,
      uploadedDocumentHashIdOfDirectors,
      setUploadedDocumentHashIdOfDirectors,
      uploadPercentageIdOfDirectors,
      setUploadPercentageIdOfDirectors,
      uploadedDocumentFATCACRS,
      setUploadedDocumentFATCACRS,
      uploadedDocumentHashFATCACRS,
      setUploadedDocumentHashFATCACRS,
      uploadPercentageFATCACRS,
      setUploadPercentageFATCACRS,
      uploadedDocumentAMLPolicy,
      setUploadedDocumentAMLPolicy,
      uploadedDocumentHashAMLPolicy,
      setUploadedDocumentHashAMLPolicy,
      uploadPercentageAMLPolicy,
      setUploadPercentageAMLPolicy,
      uploadedDocumentAnnualReport,
      setUploadedDocumentAnnualReport,
      uploadedDocumentHashAnnualReport,
      setUploadedDocumentHashAnnualReport,
      uploadPercentageAnnualReport,
      setUploadPercentageAnnualReport,
      selectedTinSec,
      setSelectedTinSec,
      uploadedDocumentTax,
      setUploadedDocumentTax,
      uploadedDocumentHashTax,
      setUploadedDocumentHashTax,
      uploadPercentageTax,
      setUploadPercentageTax,
      selectedUserType,
      setSelectedUserType,
      inputWallet1,
      setInputWallet1,
      inputWallet2,
      setInputWallet2,
      inputWallet3,
      setInputWallet3,
      inputWallet4,
      setInputWallet4,
      inputName,
      setInputName,
      inputEmail,
      setInputEmail,
      inputDate,
      setInputDate,
      inputWebsite,
      setInputWebsite,
      inputAddress,
      setInputAddress,
    },
  } = props;

  return (
    <React.Fragment>
      <p className="verify-kyc-header-text">Verified KYC-AML Questionnaire</p>
      <TaxResidencyOverlay
        selectedCountry={selectedCountry}
        setSelectedCountry={setSelectedCountry}
        searchActive={searchActive}
        setSearchActive={setSearchActive}
        newSearchContent={newSearchContent}
        setNewSearchContent={setNewSearchContent}
        countryList={countryList?.filter(
          (cnt) =>
            cnt?.code?.toLowerCase() !==
            selectedCountrySec?.code?.toLowerCase(),
        )}
        setCountryList={setCountryList}
        isCheckboxClicked={isCheckboxClicked}
        setIsCheckboxClicked={setIsCheckboxClicked}
        selectedTin={selectedTin}
        setInputTin={setInputTin}
        inputTin={inputTin}
        inputNoTin={inputNoTin}
        setInputNoTin={setInputNoTin}
        setSelectedTin={setSelectedTin}
        selectedNoTin={selectedNoTin}
        setSelectedNoTin={setSelectedNoTin}
        setKycQuestionnaire={_setKycQuestionaire}
        userAddress={userAddress}
        kycQuestionaireGen={props.KYCQuestionnaire}
      />

      <p className="verify-kyc-footer-text">
        {t("kyc.taxResidentInAnotherCountry")}
      </p>
      <div className="profile-edit-contact-body">
        <div className="select-bank-popup">
          <div className="select-bank-popup-container">
            <div className="select-bank-popup-body">
              <div className="select-bank-popup-body-container">
                <div
                  onClick={async () => {
                    setSelectedOtherTax("yes");
                    let kycQuestionaireLc =
                      JSON.parse(
                        localStorage.getItem(
                          `${userAddress?.toLowerCase()}-kyc-aml`,
                        ),
                      ) || {};
                    kycQuestionaireLc["selectedOtherTax"] =
                      await encryptKycString("yes");

                    _setKycQuestionaire((prev) => ({
                      ...prev,
                      selectedOtherTax: "yes",
                    }));
                    localStorage.setItem(
                      `${userAddress?.toLowerCase()}-kyc-aml`,
                      JSON.stringify({
                        ...kycQuestionaireLc,
                        lastUpdated: Date.now(),
                      }),
                    );
                  }}
                  className="select-bank-popup-body-content"
                >
                  <div className="select-bank-popup-body-content-container">
                    <div className="select-bank-popup-body-content-main">
                      <div className="select-bank-popup-body-content-text-container">
                        <p className="select-bank-popup-body-content-text">
                          {t("kyc.yes")}
                        </p>
                      </div>
                      {selectedOtherTax !== "yes" && (
                        <img src={selectBankCircle} alt="Checkbox Icon" />
                      )}
                      {selectedOtherTax === "yes" && (
                        <img src={selectBankClicked} alt="Checkbox Icon" />
                      )}
                    </div>
                  </div>
                </div>

                <div
                  onClick={async () => {
                    setSelectedOtherTax("no");
                    setSelectedCountrySec({
                      area: "",
                      flag: "",
                      name: "",
                      continent: "",
                      code: "",
                    });
                    let kycQuestionaireLc =
                      JSON.parse(
                        localStorage.getItem(
                          `${userAddress?.toLowerCase()}-kyc-aml`,
                        ),
                      ) || {};
                    kycQuestionaireLc["selectedOtherTax"] =
                      await encryptKycString("no");
                    kycQuestionaireLc["taxResidencySec"] = {
                      area: "",
                      flag: "",
                      name: "",
                      continent: "",
                      code: "",
                    };

                    _setKycQuestionaire((prev) => ({
                      ...prev,
                      selectedOtherTax: "no",
                      taxResidencySec: {
                        area: "",
                        flag: "",
                        name: "",
                        continent: "",
                        code: "",
                      },
                    }));
                    localStorage.setItem(
                      `${userAddress?.toLowerCase()}-kyc-aml`,
                      JSON.stringify({
                        ...kycQuestionaireLc,
                        lastUpdated: Date.now(),
                      }),
                    );
                  }}
                  className="select-bank-popup-body-content"
                >
                  <div className="select-bank-popup-body-content-container">
                    <div className="select-bank-popup-body-content-main">
                      <div className="select-bank-popup-body-content-text-container">
                        <p className="select-bank-popup-body-content-text">
                          {t("kyc.no")}
                        </p>
                      </div>
                      {selectedOtherTax !== "no" && (
                        <img src={selectBankCircle} alt="Checkbox Icon" />
                      )}
                      {selectedOtherTax === "no" && (
                        <img src={selectBankClicked} alt="Checkbox Icon" />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {selectedOtherTax === "yes" && (
        <TaxResidencyOverlay
          selectedCountry={selectedCountrySec}
          setSelectedCountry={setSelectedCountrySec}
          searchActive={searchActive}
          setSearchActive={setSearchActive}
          newSearchContent={newSearchContent}
          setNewSearchContent={setNewSearchContent}
          countryList={countryList?.filter(
            (cnt) =>
              cnt?.code?.toLowerCase() !== selectedCountry?.code?.toLowerCase(),
          )}
          setCountryList={setCountryList}
          isCheckboxClicked={isCheckboxClicked}
          setIsCheckboxClicked={setIsCheckboxClicked}
          selectedTin={selectedTinSec}
          setInputTin={setInputTin}
          inputTin={inputTin}
          setInputNoTin={setInputNoTinSec}
          inputNoTin={inputNoTinSec}
          setSelectedTin={setSelectedTinSec}
          selectedNoTin={selectedNoTinSec}
          setSelectedNoTin={setSelectedNoTinSec}
          setKycQuestionnaire={_setKycQuestionaire}
          userAddress={userAddress}
          isSec={true}
          kycQuestionaireGen={props.KYCQuestionnaire}
        />
      )}

      {selectedTin === "yes" && (
        <React.Fragment>
          <p className="verify-kyc-footer-text">{t("kyc.uploadTinDocument")}</p>
          <div className="profile-edit-contact-body">
            <UploadDocumentOverlay
              fileTypes="image/jpg,image/jpeg,image/png,image/heic,image/webp,application/pdf"
              fileTypesText="JPG, PNG, HEIC, WEBP, PDF (max 50 MB)"
              metadataName={props?.applicantName || userAddress}
              uploadedDocument={uploadedDocumentTax}
              setUploadedDocument={setUploadedDocumentTax}
              uploadedDocumentHash={uploadedDocumentHashTax}
              setUploadedDocumentHash={setUploadedDocumentHashTax}
              uploadPercentage={uploadPercentageTax}
              setUploadPercentage={setUploadPercentageTax}
              inputTagId="tax-input-tag"
              inputTagIdSec="tax-input-tag-sec"
              hashKycName="uploadedDocumentTax"
              setKycQuestionaire={_setKycQuestionaire}
              docKycName="uploadedDocumentTaxDt"
              kycQuestionaireGen={props.KYCQuestionnaire}
            />
          </div>
        </React.Fragment>
      )}

      <p className="verify-kyc-footer-text"> {t("kyc.userType")}</p>
      <div className="profile-edit-contact-body">
        <div className="select-bank-popup">
          <div className="select-bank-popup-container">
            <div className="select-bank-popup-body">
              <div className="select-bank-popup-body-container">
                <div
                  onClick={async () => {
                    setSelectedUserType("Retail Individual Investor");
                    let kycQuestionaireLc =
                      JSON.parse(
                        localStorage.getItem(
                          `${userAddress?.toLowerCase()}-kyc-aml`,
                        ),
                      ) || {};
                    kycQuestionaireLc["selectedUserType"] =
                      await encryptKycString("Retail Individual Investor");

                    _setKycQuestionaire((prev) => ({
                      ...prev,
                      selectedUserType: "Retail Individual Investor",
                    }));
                    localStorage.setItem(
                      `${userAddress?.toLowerCase()}-kyc-aml`,
                      JSON.stringify({
                        ...kycQuestionaireLc,
                        lastUpdated: Date.now(),
                      }),
                    );
                  }}
                  className="select-bank-popup-body-content"
                >
                  <div className="select-bank-popup-body-content-container">
                    <div className="select-bank-popup-body-content-main">
                      <div className="select-bank-popup-body-content-text-container">
                        <p
                          style={{ maxWidth: "300px" }}
                          className="select-bank-popup-body-content-text"
                        >
                          {t("kyc.retailIndividualInvestor")}
                        </p>
                      </div>
                      {selectedUserType !== "Retail Individual Investor" && (
                        <img src={selectBankCircle} alt="Checkbox Icon" />
                      )}
                      {selectedUserType === "Retail Individual Investor" && (
                        <img src={selectBankClicked} alt="Checkbox Icon" />
                      )}
                    </div>
                  </div>
                </div>

                <div
                  onClick={async () => {
                    setSelectedUserType(
                      "Professional / Accredited Individual Investor",
                    );
                    let kycQuestionaireLc =
                      JSON.parse(
                        localStorage.getItem(
                          `${userAddress?.toLowerCase()}-kyc-aml`,
                        ),
                      ) || {};
                    kycQuestionaireLc["selectedUserType"] =
                      await encryptKycString(
                        "Professional / Accredited Individual Investor",
                      );

                    _setKycQuestionaire((prev) => ({
                      ...prev,
                      selectedUserType:
                        "Professional / Accredited Individual Investor",
                    }));
                    localStorage.setItem(
                      `${userAddress?.toLowerCase()}-kyc-aml`,
                      JSON.stringify({
                        ...kycQuestionaireLc,
                        lastUpdated: Date.now(),
                      }),
                    );
                  }}
                  className="select-bank-popup-body-content"
                >
                  <div className="select-bank-popup-body-content-container">
                    <div className="select-bank-popup-body-content-main">
                      <div className="select-bank-popup-body-content-text-container">
                        <p
                          style={{ maxWidth: "300px" }}
                          className="select-bank-popup-body-content-text"
                        >
                          {t("kyc.professionalAccreditedIndividualInvestor")}
                        </p>
                      </div>
                      {selectedUserType !==
                        "Professional / Accredited Individual Investor" && (
                        <img src={selectBankCircle} alt="Checkbox Icon" />
                      )}
                      {selectedUserType ===
                        "Professional / Accredited Individual Investor" && (
                        <img src={selectBankClicked} alt="Checkbox Icon" />
                      )}
                    </div>
                  </div>
                </div>

                <div
                  onClick={async () => {
                    setSelectedUserType("Institutional Investor");
                    let kycQuestionaireLc =
                      JSON.parse(
                        localStorage.getItem(
                          `${userAddress?.toLowerCase()}-kyc-aml`,
                        ),
                      ) || {};
                    kycQuestionaireLc["selectedUserType"] =
                      await encryptKycString("Institutional Investor");

                    _setKycQuestionaire((prev) => ({
                      ...prev,
                      selectedUserType: "Institutional Investor",
                    }));
                    localStorage.setItem(
                      `${userAddress?.toLowerCase()}-kyc-aml`,
                      JSON.stringify({
                        ...kycQuestionaireLc,
                        lastUpdated: Date.now(),
                      }),
                    );
                  }}
                  className="select-bank-popup-body-content"
                >
                  <div className="select-bank-popup-body-content-container">
                    <div className="select-bank-popup-body-content-main">
                      <div className="select-bank-popup-body-content-text-container">
                        <p
                          style={{ maxWidth: "300px" }}
                          className="select-bank-popup-body-content-text"
                        >
                          {t("kyc.institutionalInvestor")}
                        </p>
                      </div>
                      {selectedUserType !== "Institutional Investor" && (
                        <img src={selectBankCircle} alt="Checkbox Icon" />
                      )}
                      {selectedUserType === "Institutional Investor" && (
                        <img src={selectBankClicked} alt="Checkbox Icon" />
                      )}
                    </div>
                  </div>
                </div>

                <div
                  onClick={async () => {
                    setSelectedUserType("Other Companies");
                    let kycQuestionaireLc =
                      JSON.parse(
                        localStorage.getItem(
                          `${userAddress?.toLowerCase()}-kyc-aml`,
                        ),
                      ) || {};
                    kycQuestionaireLc["selectedUserType"] =
                      await encryptKycString("Other Companies");

                    _setKycQuestionaire((prev) => ({
                      ...prev,
                      selectedUserType: "Other Companies",
                    }));
                    localStorage.setItem(
                      `${userAddress?.toLowerCase()}-kyc-aml`,
                      JSON.stringify({
                        ...kycQuestionaireLc,
                        lastUpdated: Date.now(),
                      }),
                    );
                  }}
                  className="select-bank-popup-body-content"
                >
                  <div className="select-bank-popup-body-content-container">
                    <div className="select-bank-popup-body-content-main">
                      <div className="select-bank-popup-body-content-text-container">
                        <p
                          style={{ maxWidth: "300px" }}
                          className="select-bank-popup-body-content-text"
                        >
                          {t("kyc.otherCompanies")}
                        </p>
                      </div>
                      {selectedUserType !== "Other Companies" && (
                        <img src={selectBankCircle} alt="Checkbox Icon" />
                      )}
                      {selectedUserType === "Other Companies" && (
                        <img src={selectBankClicked} alt="Checkbox Icon" />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {selectedUserType?.length > 0 &&
        selectedUserType !== "Retail Individual Investor" && (
          <React.Fragment>
            <p className="verify-kyc-footer-text"> {t("kyc.name")}</p>

            <div className="profile-edit-contact-body">
              <input
                name="name-input"
                style={{
                  border: "1px solid var(--Neutral-100, #eeeef0)",
                  background: "transparent",
                  fontWeight: "600",
                }}
                value={inputName}
                onInput={async (e) => {
                  setInputName(e.target.value);
                  let kycQuestionaireLc =
                    JSON.parse(
                      localStorage.getItem(
                        `${userAddress?.toLowerCase()}-kyc-aml`,
                      ),
                    ) || {};
                  kycQuestionaireLc["inputName"] = await encryptKycString(
                    e.target.value,
                  );
                  _setKycQuestionaire((prev) => ({
                    ...prev,
                    inputName: e.target.value,
                  }));

                  localStorage.setItem(
                    `${userAddress?.toLowerCase()}-kyc-aml`,
                    JSON.stringify({
                      ...kycQuestionaireLc,
                      lastUpdated: Date.now(),
                    }),
                  );
                }}
                type="text"
                className="offer-security-popup-input"
                placeholder={t("placeholder.enterName")}
              />
            </div>

            {selectedUserType !==
              "Professional / Accredited Individual Investor" && (
              <React.Fragment>
                <p className="verify-kyc-footer-text">
                  {t("kyc.dateOfIncorporation")}
                </p>

                <div className="profile-edit-contact-body">
                  <input
                    name="name-input"
                    style={{
                      border: "1px solid var(--Neutral-100, #eeeef0)",
                      background: "transparent",
                      fontWeight: "600",
                      display: "unset",
                    }}
                    value={inputDate}
                    onInput={async (e) => {
                      setInputDate(e.target.value);
                      let kycQuestionaireLc =
                        JSON.parse(
                          localStorage.getItem(
                            `${userAddress?.toLowerCase()}-kyc-aml`,
                          ),
                        ) || {};
                      kycQuestionaireLc["inputDate"] = await encryptKycString(
                        e.target.value,
                      );

                      _setKycQuestionaire((prev) => ({
                        ...prev,
                        inputDate: e.target.value,
                      }));
                      localStorage.setItem(
                        `${userAddress?.toLowerCase()}-kyc-aml`,
                        JSON.stringify({
                          ...kycQuestionaireLc,
                          lastUpdated: Date.now(),
                        }),
                      );
                    }}
                    type="date"
                    max="9999-12-31"
                    className="offer-security-popup-input"
                    placeholder={t("placeholder.enterName")}
                  />
                </div>

                <p className="verify-kyc-footer-text">
                  {t("kyc.countryOfRegistration")}
                </p>
                <div className="profile-edit-contact-body">
                  <div className="profile-edit-contact-content">
                    <div className="profile-edit-contact-input-container">
                      <div className="profile-edit-contact-input">
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "space-between",
                            background: "transparent",
                            border: "1px solid var(--Neutral-100, #eeeef0)",
                          }}
                          onClick={() => {
                            setSearchActive(!searchActive);
                          }}
                          className="profile-edit-contact-first-section"
                        >
                          <div className="profile-edit-contact-selection-icon">
                            {selectedCountry.flag?.length > 0 && (
                              <img
                                onClick={() => {
                                  setSearchActive(!searchActive);
                                }}
                                style={{
                                  minHeight: "24px",
                                  minWidth: "24px",
                                }}
                                alt="Country Flag"
                                src={selectedCountryInc.flag}
                              />
                            )}
                          </div>
                          <p
                            style={{
                              width: "fit-content",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setSearchActive(!searchActive);
                            }}
                            className="profile-edit-contact-selection-text"
                          >
                            {selectedCountryInc.name?.length > 0
                              ? selectedCountryInc.name
                              : "Select Country Of Registration"}
                          </p>

                          {searchActive && (
                            <img
                              onClick={() => {
                                setSearchActive(!searchActive);
                              }}
                              alt="Dropdown Icon"
                              src={arrowUp}
                            />
                          )}
                          {!searchActive && (
                            <img
                              onClick={() => {
                                setSearchActive(!searchActive);
                              }}
                              alt="Dropdown Icon"
                              src={dropdownIcon}
                            />
                          )}
                        </div>
                      </div>
                      {searchActive && (
                        <>
                          {!countryList && <p>{t("common.loading")}...</p>}
                          {countryList && countryList?.length > 0 && (
                            <div className="mobille-startup-search-box-container">
                              <div className="mobile-startup-search-box">
                                <img
                                  src={searchIcon}
                                  alt="Search Icon"
                                  className="mobile-search-icon"
                                />
                                <input
                                  onInput={(e) => {
                                    if (e.target.value === "") {
                                      setNewSearchContent(null);
                                    } else {
                                      setNewSearchContent(
                                        countryList?.filter(
                                          // eslint-disable-next-line array-callback-return
                                          (src) => {
                                            if (
                                              src.name
                                                .toLowerCase()
                                                .includes(
                                                  e.target.value.toLowerCase(),
                                                )
                                            ) {
                                              src.searched =
                                                e.target.value.toLowerCase();
                                              src.nameArray =
                                                src.name.split("");
                                              return src;
                                            }
                                          },
                                        ),
                                      );
                                    }
                                  }}
                                  type="text"
                                  className="ms-search-box-content"
                                  placeholder={t("placeholder.search")}
                                />
                              </div>
                              <div className="mobile-startup-search-content">
                                <div
                                  style={
                                    props.contentMaxHeight
                                      ? {
                                          maxHeight: `${props.contentMaxHeight}px`,
                                        }
                                      : {}
                                  }
                                  className="ms-search-content-container"
                                >
                                  {!newSearchContent &&
                                    countryList?.length > 0 &&
                                    countryList?.map((src, idx) => (
                                      <div
                                        key={idx}
                                        onClickCapture={() => {
                                          setSelectedCountryInc({
                                            area: src?.phone_code,
                                            flag: src?.flag,
                                            name: src.name,
                                            continent: src.continent,
                                            code: src?.code?.toUpperCase(),
                                          });
                                          if (
                                            src?.code?.toLowerCase() === "ch"
                                          ) {
                                            setIsCheckboxClicked(false);
                                          }
                                        }}
                                        onClick={() => {
                                          setSelectedCountryInc({
                                            area: src?.phone_code,
                                            flag: src?.flag,
                                            name: src.name,
                                            continent: src.continent,
                                            code: src?.code?.toUpperCase(),
                                          });
                                          let kycQuestionaireLc =
                                            JSON.parse(
                                              localStorage.getItem(
                                                `${userAddress?.toLowerCase()}-kyc-aml`,
                                              ),
                                            ) || {};
                                          kycQuestionaireLc[
                                            "registrationCountry"
                                          ] = {
                                            area: src?.phone_code,
                                            flag: src?.flag,
                                            name: src.name,
                                            continent: src.continent,
                                            code: src?.code?.toUpperCase(),
                                          };

                                          _setKycQuestionaire((prev) => ({
                                            ...prev,
                                            registrationCountry: {
                                              area: src?.phone_code,
                                              flag: src?.flag,
                                              name: src.name,
                                              continent: src.continent,
                                              code: src?.code?.toUpperCase(),
                                            },
                                          }));
                                          localStorage.setItem(
                                            `${userAddress?.toLowerCase()}-kyc-aml`,
                                            JSON.stringify({
                                              ...kycQuestionaireLc,
                                              lastUpdated: Date.now(),
                                            }),
                                          );
                                          if (setSearchActive) {
                                            setSearchActive(!searchActive);
                                          }
                                          setNewSearchContent(null);

                                          if (
                                            src?.code?.toLowerCase() === "ch"
                                          ) {
                                            setIsCheckboxClicked(false);
                                          }
                                        }}
                                        className="ms-search-content"
                                      >
                                        <img
                                          src={src?.flag}
                                          alt="Search Result Icon"
                                          className="ms-search-content-icon"
                                        />
                                        <p className="ms-search-content-text">
                                          {src.name}
                                        </p>
                                      </div>
                                    ))}

                                  {newSearchContent &&
                                    newSearchContent.length > 0 &&
                                    newSearchContent.map((src, idx) => (
                                      <div
                                        key={idx}
                                        onClickCapture={() => {
                                          setSelectedCountryInc({
                                            area: src?.phone_code,
                                            flag: src?.flag,
                                            name: src.name,
                                            continent: src.continent,
                                            code: src?.code?.toUpperCase(),
                                          });
                                          if (
                                            src?.code?.toLowerCase() === "ch"
                                          ) {
                                            setIsCheckboxClicked(false);
                                          }
                                        }}
                                        onClick={() => {
                                          setSelectedCountryInc({
                                            area: src?.phone_code,
                                            flag: src?.flag,
                                            name: src.name,
                                            continent: src.continent,
                                            code: src?.code?.toUpperCase(),
                                          });
                                          let kycQuestionaireLc =
                                            JSON.parse(
                                              localStorage.getItem(
                                                `${userAddress?.toLowerCase()}-kyc-aml`,
                                              ),
                                            ) || {};
                                          kycQuestionaireLc[
                                            "registrationCountry"
                                          ] = {
                                            area: src?.phone_code,
                                            flag: src?.flag,
                                            name: src.name,
                                            continent: src.continent,
                                            code: src?.code?.toUpperCase(),
                                          };

                                          _setKycQuestionaire((prev) => ({
                                            ...prev,
                                            registrationCountry: {
                                              area: src?.phone_code,
                                              flag: src?.flag,
                                              name: src.name,
                                              continent: src.continent,
                                              code: src?.code?.toUpperCase(),
                                            },
                                          }));
                                          localStorage.setItem(
                                            `${userAddress?.toLowerCase()}-kyc-aml`,
                                            JSON.stringify({
                                              ...kycQuestionaireLc,
                                              lastUpdated: Date.now(),
                                            }),
                                          );
                                          if (setSearchActive) {
                                            setSearchActive(!searchActive);
                                          }
                                          setNewSearchContent(null);

                                          if (
                                            src?.code?.toLowerCase() === "ch"
                                          ) {
                                            setIsCheckboxClicked(false);
                                          }
                                        }}
                                        className="ms-search-content"
                                      >
                                        <img
                                          src={src?.flag}
                                          alt="Search Result Icon"
                                          className="ms-search-content-icon"
                                        />
                                        <p className="ms-search-content-text">
                                          {src.nameArray?.length > 0 &&
                                            src.nameArray.map((nm, idx) => (
                                              <>
                                                {!src.searched.includes(
                                                  nm.toLowerCase(),
                                                ) && (
                                                  <span
                                                    key={idx}
                                                    style={{
                                                      color: "#B6B7C3",
                                                    }}
                                                  >
                                                    {nm}
                                                  </span>
                                                )}
                                                {src.searched.includes(
                                                  nm.toLowerCase(),
                                                ) && (
                                                  <span key={idx}>{nm}</span>
                                                )}
                                              </>
                                            ))}
                                        </p>
                                      </div>
                                    ))}
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>

                <p className="verify-kyc-footer-text">Website</p>

                <div className="profile-edit-contact-body">
                  <input
                    name="website-input"
                    style={{
                      border: "1px solid var(--Neutral-100, #eeeef0)",
                      background: "transparent",
                      fontWeight: "600",
                    }}
                    value={inputWebsite}
                    onInput={async (e) => {
                      setInputWebsite(e.target.value);
                      let kycQuestionaireLc =
                        JSON.parse(
                          localStorage.getItem(
                            `${userAddress?.toLowerCase()}-kyc-aml`,
                          ),
                        ) || {};
                      kycQuestionaireLc["inputWebsite"] =
                        await encryptKycString(e.target.value);

                      _setKycQuestionaire((prev) => ({
                        ...prev,
                        inputWebsite: e.target.value,
                      }));
                      localStorage.setItem(
                        `${userAddress?.toLowerCase()}-kyc-aml`,
                        JSON.stringify({
                          ...kycQuestionaireLc,
                          lastUpdated: Date.now(),
                        }),
                      );
                    }}
                    type="text"
                    className="offer-security-popup-input"
                    placeholder={t("placeholder.websiteUrl")}
                  />
                </div>
              </React.Fragment>
            )}

            <p className="verify-kyc-footer-text">
              {" "}
              {t("kyc.registeredAddress")}
            </p>
            <div className="profile-edit-contact-body">
              <textarea
                name="address-input"
                style={{
                  border: "1px solid var(--Neutral-100, #eeeef0)",
                  background: "transparent",

                  fontWeight: "500",
                  minHeight: "60px",
                  width: "100%",
                }}
                value={inputAddress}
                onInput={async (e) => {
                  setInputAddress(e.target.value);
                  let kycQuestionaireLc =
                    JSON.parse(
                      localStorage.getItem(
                        `${userAddress?.toLowerCase()}-kyc-aml`,
                      ),
                    ) || {};
                  kycQuestionaireLc["inputAddress"] = await encryptKycString(
                    e.target.value,
                  );

                  _setKycQuestionaire((prev) => ({
                    ...prev,
                    inputAddress: e.target.value,
                  }));
                  localStorage.setItem(
                    `${userAddress?.toLowerCase()}-kyc-aml`,
                    JSON.stringify({
                      ...kycQuestionaireLc,
                      lastUpdated: Date.now(),
                    }),
                  );
                }}
                type="text"
                className="offer-security-popup-input"
                placeholder={t("placeholder.registeredAddress")}
              ></textarea>
            </div>

            <p className="verify-kyc-footer-text">{t("kyc.emailAddress")}</p>

            <div className="profile-edit-contact-body">
              <input
                name="email-input"
                style={{
                  border: "1px solid var(--Neutral-100, #eeeef0)",
                  background: "transparent",
                  fontWeight: "600",
                }}
                value={inputEmail}
                onInput={async (e) => {
                  setInputEmail(e.target.value);
                  let kycQuestionaireLc =
                    JSON.parse(
                      localStorage.getItem(
                        `${userAddress?.toLowerCase()}-kyc-aml`,
                      ),
                    ) || {};
                  kycQuestionaireLc["inputEmail"] = await encryptKycString(
                    e.target.value,
                  );

                  _setKycQuestionaire((prev) => ({
                    ...prev,
                    inputEmail: e.target.value,
                  }));
                  localStorage.setItem(
                    `${userAddress?.toLowerCase()}-kyc-aml`,
                    JSON.stringify({
                      ...kycQuestionaireLc,
                      lastUpdated: Date.now(),
                    }),
                  );
                }}
                type="text"
                className="offer-security-popup-input"
                placeholder={t("placeholder.emailAddress")}
              />
            </div>

            <p
              style={{
                fontWeight: "300",
                display: "flex",
                gap: "8px",
                flexDirection: "column",
                maxWidth: "300px",
                color: "#e23636",
              }}
              className="select-bank-popup-body-content-text"
            >
              <span
                style={{ color: "#e23636" }}
                className="select-bank-popup-body-content-text"
              >
                {t("kyc.certifiedTrueCopyInstruction")}
              </span>

              <span
                style={{ color: "#e23636" }}
                className="select-bank-popup-body-content-text"
              >
                {t("kyc.certifiedTrueCopyDefinition")}
              </span>

              <span
                style={{ color: "#e23636" }}
                className="select-bank-popup-body-content-text"
              >
                {t("kyc.acceptableCertifiers")}
              </span>

              <span
                style={{ background: "black", color: "white" }}
                className="select-bank-popup-body-content-text"
              >
                - {t("kyc.lawyerOrNotary")}
              </span>

              <span
                style={{ background: "black", color: "white" }}
                className="select-bank-popup-body-content-text"
              >
                - {t("kyc.judiciaryOrSeniorCivilServant")}
              </span>

              <span
                style={{ background: "black", color: "white" }}
                className="select-bank-popup-body-content-text"
              >
                - {t("kyc.embassyOfficer")}
              </span>

              <span
                style={{ background: "black", color: "white" }}
                className="select-bank-popup-body-content-text"
              >
                - {t("kyc.actuary")}
              </span>

              <span
                style={{ background: "black", color: "white" }}
                className="select-bank-popup-body-content-text"
              >
                - {t("kyc.accountant")}
              </span>

              <span
                style={{ background: "black", color: "white" }}
                className="select-bank-popup-body-content-text"
              >
                - {t("kyc.instituteOfCharteredSecretaries")}
              </span>

              <span
                style={{ background: "black", color: "white" }}
                className="select-bank-popup-body-content-text"
              >
                - {t("kyc.regulatedFinancialServicesDirector")}
              </span>

              <span
                style={{ color: "#e23636" }}
                className="select-bank-popup-body-content-text"
              >
                The persons above should use the following form of
                certification:
              </span>
              <span
                style={{ background: "black", color: "white" }}
                className="select-bank-popup-body-content-text"
              >
                {t("kyc.certificationForm")}
              </span>
              <span
                style={{ color: "#e23636" }}
                className="select-bank-popup-body-content-text"
              >
                {t("kyc.certifierRequirements")}
              </span>
              <span
                style={{ background: "black", color: "white" }}
                className="select-bank-popup-body-content-text"
              >
                - {t("kyc.dateAndSignCopy")}
              </span>
              <span
                style={{ background: "black", color: "white" }}
                className="select-bank-popup-body-content-text"
              >
                - {t("kyc.certifierPosition")}
              </span>
              <span
                style={{ background: "black", color: "white" }}
                className="select-bank-popup-body-content-text"
              >
                - {t("kyc.certificationLocation")}
              </span>
              <span
                style={{ background: "black", color: "white" }}
                className="select-bank-popup-body-content-text"
              >
                - {t("kyc.certifierContactDetails")}
              </span>
            </p>

            <React.Fragment>
              <p className="verify-kyc-footer-text">
                {selectedUserType !==
                "Professional / Accredited Individual Investor"
                  ? "Upload filled and signed Form W-8BEN-E"
                  : "Upload Form W8-BEN for Professional / Accredited Individual Investor ONLY"}
              </p>
              <p
                style={{
                  fontWeight: "300",
                  display: "flex",
                  gap: "8px",
                  flexDirection: "column",
                  maxWidth: "300px",
                }}
                className="select-bank-popup-body-content-text"
              >
                <span className="select-bank-popup-body-content-text">
                  {selectedUserType !==
                  "Professional / Accredited Individual Investor"
                    ? "We required by regulator to ask clients to provide W-8BEN-E form."
                    : "We required by regulator to ask Professional / Accredited Individual"}
                </span>

                <span
                  style={{ color: "blue", cursor: "pointer" }}
                  onClick={() => {
                    window.open(
                      selectedUserType !==
                        "Professional / Accredited Individual Investor"
                        ? "https://www.irs.gov/pub/irs-pdf/fw8bene.pdf"
                        : "https://www.irs.gov/pub/irs-pdf/fw8ben.pdf",
                      "_blank",
                    );
                  }}
                  className="select-bank-popup-body-content-text"
                >
                  {selectedUserType !==
                  "Professional / Accredited Individual Investor"
                    ? "Download the Form W-8BEN-E"
                    : "Download the Form W-8BEN"}
                </span>

                <span
                  style={{
                    color: "blue",
                    cursor: "pointer",
                    fontWeight: "400",
                  }}
                  onClick={() => {
                    window.open(
                      "https://www.irs.gov/pub/irs-pdf/iw8ben.pdf",
                      selectedUserType !==
                        "Professional / Accredited Individual Investor"
                        ? "https://www.irs.gov/pub/irs-pdf/iw8bene.pdf"
                        : "https://www.irs.gov/pub/irs-pdf/iw8ben.pdf",
                      "_blank",
                    );
                  }}
                  className="select-bank-popup-body-content-text"
                >
                  {selectedUserType !==
                  "Professional / Accredited Individual Investor"
                    ? "Instructions for Form W-8BEN-E"
                    : "Instructions for Form W-8BEN"}
                </span>
              </p>
              <div className="profile-edit-contact-body">
                <UploadDocumentOverlay
                  fileTypes="image/jpg,image/jpeg,image/png,image/heic,image/webp,application/pdf"
                  fileTypesText="JPG, PNG, HEIC, WEBP, PDF (max 50 MB)"
                  metadataName={props?.applicantName || userAddress}
                  uploadedDocument={uploadedDocumentW8}
                  setUploadedDocument={setUploadedDocumentW8}
                  uploadedDocumentHash={uploadedDocumentHashW8}
                  setUploadedDocumentHash={setUploadedDocumentHashW8}
                  uploadPercentage={uploadPercentageW8}
                  setUploadPercentage={setUploadPercentageW8}
                  inputTagId="w8-input-tag"
                  inputTagIdSec="w8-input-tag-sec"
                  hashKycName="uploadedDocumentW8"
                  docKycName="uploadedDocumentW8Dt"
                  setKycQuestionaire={_setKycQuestionaire}
                  kycQuestionaireGen={props.KYCQuestionnaire}
                />
              </div>
            </React.Fragment>

            <p className="verify-kyc-footer-text">
              {t("kyc.sourceOfWealthOfUbo")} (
              <span style={{ color: "#e23636" }}>
                {t("kyc.certifiedTrueCopy")}
              </span>
              )
            </p>
            <p
              style={{
                fontWeight: "300",
                display: "flex",
                gap: "8px",
                flexDirection: "column",
                maxWidth: "300px",
              }}
              className="select-bank-popup-body-content-text"
            >
              <span className="select-bank-popup-body-content-text">
                {t("kyc.sourceOfWealthDescription")}
              </span>
            </p>

            <div className="profile-edit-contact-body">
              <UploadDocumentOverlay
                fileTypes="image/jpg,image/jpeg,image/png,image/heic,image/webp,application/pdf"
                fileTypesText="JPG, PNG, HEIC, WEBP, PDF (max 50 MB)"
                metadataName={props?.applicantName || userAddress}
                uploadedDocument={uploadedDocumentUBOSource}
                setUploadedDocument={setUploadedDocumentUBOSource}
                uploadedDocumentHash={uploadedDocumentHashUBOSource}
                setUploadedDocumentHash={setUploadedDocumentHashUBOSource}
                uploadPercentage={uploadPercentageUBOSource}
                setUploadPercentage={setUploadPercentageUBOSource}
                inputTagId="ubo-source-input-tag"
                inputTagIdSec="ubo-source-tag-sec"
                hashKycName="uploadedDocumentUBOSource"
                docKycName="uploadedDocumentUBOSourceDt"
                setKycQuestionaire={_setKycQuestionaire}
                kycQuestionaireGen={props.KYCQuestionnaire}
              />
            </div>

            {selectedUserType !==
              "Professional / Accredited Individual Investor" && (
              <React.Fragment>
                <p className="verify-kyc-footer-text">
                  {t("kyc.proofOfRegulation")} (
                  <span style={{ color: "#e23636" }}>
                    {t("kyc.certifiedTrueCopy")}
                  </span>
                  )
                </p>
                <p
                  style={{
                    fontWeight: "300",
                    display: "flex",
                    gap: "8px",
                    flexDirection: "column",
                    maxWidth: "300px",
                  }}
                  className="select-bank-popup-body-content-text"
                >
                  <span className="select-bank-popup-body-content-text">
                    {t("kyc.registrationCertificate")}
                  </span>
                </p>
                <div className="profile-edit-contact-body">
                  <UploadDocumentOverlay
                    fileTypes="image/jpg,image/jpeg,image/png,image/heic,image/webp,application/pdf"
                    fileTypesText="JPG, PNG, HEIC, WEBP or PDF (max 50 MB)"
                    metadataName={props?.applicantName || userAddress}
                    uploadedDocument={uploadedDocumentProofOfRegulation}
                    setUploadedDocument={setUploadedDocumentProofOfRegulation}
                    uploadedDocumentHash={uploadedDocumentHashProofOfRegulation}
                    setUploadedDocumentHash={
                      setUploadedDocumentHashProofOfRegulation
                    }
                    uploadPercentage={uploadPercentageProofOfRegulation}
                    setUploadPercentage={setUploadPercentageProofOfRegulation}
                    inputTagId="proofOfRegulation-input-tag"
                    inputTagIdSec="proofOfRegulation-input-tag-sec"
                    hashKycName="uploadedDocumentProofOfRegulation"
                    docKycName="uploadedDocumentProofOfRegulationDt"
                    setKycQuestionaire={_setKycQuestionaire}
                    kycQuestionaireGen={props.KYCQuestionnaire}
                  />
                </div>

                <p className="verify-kyc-footer-text">
                  {t("kyc.articlesAndMemorandum")} (
                  <span style={{ color: "#e23636" }}>
                    {t("kyc.certifiedTrueCopy")}
                  </span>
                  )
                </p>
                <p
                  style={{
                    fontWeight: "300",
                    display: "flex",
                    gap: "8px",
                    flexDirection: "column",
                    maxWidth: "300px",
                  }}
                  className="select-bank-popup-body-content-text"
                >
                  <span className="select-bank-popup-body-content-text">
                    {t("kyc.companyDocuments")}
                  </span>
                </p>
                <div className="profile-edit-contact-body">
                  <UploadDocumentOverlay
                    fileTypes="image/jpg,image/jpeg,image/png,image/heic,image/webp,application/pdf"
                    fileTypesText="JPG, PNG, HEIC, WEBP or PDF (max 50 MB)"
                    metadataName={props?.applicantName || userAddress}
                    uploadedDocument={uploadedDocumentArticlesOfAssociation}
                    setUploadedDocument={
                      setUploadedDocumentArticlesOfAssociation
                    }
                    uploadedDocumentHash={
                      uploadedDocumentHashArticlesOfAssociation
                    }
                    setUploadedDocumentHash={
                      setUploadedDocumentHashArticlesOfAssociation
                    }
                    uploadPercentage={uploadPercentageArticlesOfAssociation}
                    setUploadPercentage={
                      setUploadPercentageArticlesOfAssociation
                    }
                    inputTagId="articlesOfAssociation-input-tag"
                    inputTagIdSec="articlesOfAssociation-input-tag-sec"
                    hashKycName="uploadedDocumentArticlesOfAssociation"
                    docKycName="uploadedDocumentArticlesOfAssociationDt"
                    setKycQuestionaire={_setKycQuestionaire}
                    kycQuestionaireGen={props.KYCQuestionnaire}
                  />
                </div>

                <p className="verify-kyc-footer-text">
                  {t("kyc.ownershipAndControlStructureChart")} (
                  <span style={{ color: "#e23636" }}>
                    {t("kyc.certifiedTrueCopy")}
                  </span>
                  )
                </p>
                <p
                  style={{
                    fontWeight: "300",
                    display: "flex",
                    gap: "8px",
                    flexDirection: "column",
                    maxWidth: "300px",
                  }}
                  className="select-bank-popup-body-content-text"
                >
                  <span className="select-bank-popup-body-content-text">
                    {t("kyc.ownershipStructurePdf")}
                  </span>

                  <span className="select-bank-popup-body-content-text">
                    {t("kyc.ownershipStructureCertification")}
                  </span>
                </p>
                <div className="profile-edit-contact-body">
                  <UploadDocumentOverlay
                    fileTypes="image/jpg,image/jpeg,image/png,image/heic,image/webp,application/pdf"
                    fileTypesText="JPG, PNG, HEIC, WEBP or PDF (max 50 MB)"
                    metadataName={props?.applicantName || userAddress}
                    uploadedDocument={uploadedDocumentOwnerShipAndCSChart}
                    setUploadedDocument={setUploadedDocumentOwnerShipAndCSChart}
                    uploadedDocumentHash={
                      uploadedDocumentHashOwnerShipAndCSChart
                    }
                    setUploadedDocumentHash={
                      setUploadedDocumentHashOwnerShipAndCSChart
                    }
                    uploadPercentage={uploadPercentageOwnerShipAndCSChart}
                    setUploadPercentage={setUploadPercentageOwnerShipAndCSChart}
                    inputTagId="ownershipAndCSChart-input-tag"
                    inputTagIdSec="ownershipAndCSChart-input-tag-sec"
                    hashKycName="uploadedDocumentOwnerShipAndCSChart"
                    docKycName="uploadedDocumentOwnerShipAndCSChartDt"
                    setKycQuestionaire={_setKycQuestionaire}
                    kycQuestionaireGen={props.KYCQuestionnaire}
                  />
                </div>

                <p className="verify-kyc-footer-text">
                  {t("kyc.registerOfDirectors")} (
                  <span style={{ color: "#e23636" }}>
                    {t("kyc.certifiedTrueCopy")}
                  </span>
                  )
                </p>
                <p
                  style={{
                    fontWeight: "300",
                    display: "flex",
                    gap: "8px",
                    flexDirection: "column",
                    maxWidth: "300px",
                  }}
                  className="select-bank-popup-body-content-text"
                >
                  <span className="select-bank-popup-body-content-text">
                    {t("kyc.registerOfDirectorsDetails")}
                  </span>

                  <span className="select-bank-popup-body-content-text">
                    Directors official full name, date and place of birth,
                    permanent address, email-id, identity reference number and
                    nationality.
                  </span>

                  <span className="select-bank-popup-body-content-text">
                    For corporate director we require the full name, email-id,
                    registration number, date of incorporation and registered
                    address or principal place of business of the corporate
                    entity.
                  </span>

                  <span className="select-bank-popup-body-content-text">
                    For Partnership, provide on the General Partner.
                  </span>

                  <span className="select-bank-popup-body-content-text">
                    Each page of the document to be certified if more than one
                    else, at the end of the document.
                  </span>
                </p>
                <div className="profile-edit-contact-body">
                  <UploadDocumentOverlay
                    fileTypes="image/jpg,image/jpeg,image/png,image/heic,image/webp,application/pdf"
                    fileTypesText="JPG, PNG, HEIC, WEBP or PDF (max 50 MB)"
                    metadataName={props?.applicantName || userAddress}
                    uploadedDocument={uploadedDocumentRegisterOfDirectors}
                    setUploadedDocument={setUploadedDocumentRegisterOfDirectors}
                    uploadedDocumentHash={
                      uploadedDocumentHashRegisterOfDirectors
                    }
                    setUploadedDocumentHash={
                      setUploadedDocumentHashRegisterOfDirectors
                    }
                    uploadPercentage={uploadPercentageRegisterOfDirectors}
                    setUploadPercentage={setUploadPercentageRegisterOfDirectors}
                    inputTagId="registerOfDirectors-input-tag"
                    inputTagIdSec="registerOfDirectors-input-tag-sec"
                    hashKycName="uploadedDocumentRegisterOfDirectors"
                    docKycName="uploadedDocumentRegisterOfDirectorsDt"
                    setKycQuestionaire={_setKycQuestionaire}
                    kycQuestionaireGen={props.KYCQuestionnaire}
                  />
                </div>

                <p className="verify-kyc-footer-text">
                  {t("kyc.authorisedSignatoryList")} (
                  <span style={{ color: "#e23636" }}>
                    {t("kyc.certifiedTrueCopy")}
                  </span>
                  )
                </p>
                <p
                  style={{
                    fontWeight: "300",
                    display: "flex",
                    gap: "8px",
                    flexDirection: "column",
                    maxWidth: "300px",
                  }}
                  className="select-bank-popup-body-content-text"
                >
                  <span className="select-bank-popup-body-content-text">
                    A PDF file consisting of Authorized Signatories - Full Name,
                    Address, Contact number, PAN / DIN / registration number/
                    identification number and signature specimen (Signature
                    Samples of the authorized person of the company for doing
                    signature on behalf of the company).
                  </span>

                  <span className="select-bank-popup-body-content-text">
                    Signed by a Director, the Company Secretary or the General
                    Partner including samples of all signatures and the details
                    of any signing protocol.
                  </span>

                  <span className="select-bank-popup-body-content-text">
                    Each page of the document to be certified if more than one
                    else, at the end of the document.
                  </span>
                </p>
                <div className="profile-edit-contact-body">
                  <UploadDocumentOverlay
                    fileTypes="image/jpg,image/jpeg,image/png,image/heic,image/webp,application/pdf"
                    fileTypesText="JPG, PNG, HEIC, WEBP or PDF (max 50 MB)"
                    metadataName={props?.applicantName || userAddress}
                    uploadedDocument={uploadedDocumentSignatoryList}
                    setUploadedDocument={setUploadedDocumentSignatoryList}
                    uploadedDocumentHash={uploadedDocumentHashSignatoryList}
                    setUploadedDocumentHash={
                      setUploadedDocumentHashSignatoryList
                    }
                    uploadPercentage={uploadPercentageSignatoryList}
                    setUploadPercentage={setUploadPercentageSignatoryList}
                    inputTagId="signatoryList-input-tag"
                    inputTagIdSec="signatoryList-input-tag-sec"
                    hashKycName="uploadedDocumentSignatoryList"
                    docKycName="uploadedDocumentSignatoryListDt"
                    setKycQuestionaire={_setKycQuestionaire}
                    kycQuestionaireGen={props.KYCQuestionnaire}
                  />
                </div>

                <p className="verify-kyc-footer-text">
                  {t("kyc.ultimateBeneficialOwnerDeclaration")} (
                  <span style={{ color: "#e23636" }}>
                    {t("kyc.certifiedTrueCopy")}
                  </span>
                  )
                </p>
                <p
                  style={{
                    fontWeight: "300",
                    display: "flex",
                    gap: "8px",
                    flexDirection: "column",
                    maxWidth: "300px",
                  }}
                  className="select-bank-popup-body-content-text"
                >
                  <span className="select-bank-popup-body-content-text">
                    Beneficiaries owning directly or indirectly 10% or more of
                    the company’s shares. Declaration Form to be filled for each
                    UBO here separately.
                  </span>

                  <span className="select-bank-popup-body-content-text">
                    Please fill, be dated and signed by authorized signatories
                    of the company and upload here.
                  </span>

                  <a
                    style={{ color: "blue", cursor: "pointer" }}
                    target="_blank"
                    rel="noreferrer"
                    href="https://verified-kyc.s3.amazonaws.com/Ultimate+Beneficial+Owner+(UBO)+Declaration.docx"
                    className="select-bank-popup-body-content-text"
                  >
                    {t("kyc.downloadUboForm")}
                  </a>
                </p>
                <div className="profile-edit-contact-body">
                  <UploadDocumentOverlay
                    fileTypes="image/jpg,image/jpeg,image/png,image/heic,image/webp,application/pdf"
                    fileTypesText="JPG, PNG, HEIC, WEBP or PDF (max 50 MB)"
                    metadataName={props?.applicantName || userAddress}
                    uploadedDocument={uploadedDocumentUBO}
                    setUploadedDocument={setUploadedDocumentUBO}
                    uploadedDocumentHash={uploadedDocumentHashUBO}
                    setUploadedDocumentHash={setUploadedDocumentHashUBO}
                    uploadPercentage={uploadPercentageUBO}
                    setUploadPercentage={setUploadPercentageUBO}
                    inputTagId="ubo-input-tag"
                    inputTagIdSec="ubo-input-tag-sec"
                    hashKycName="uploadedDocumentUBO"
                    docKycName="uploadedDocumentUBODt"
                    setKycQuestionaire={_setKycQuestionaire}
                    kycQuestionaireGen={props.KYCQuestionnaire}
                  />
                </div>

                <p className="verify-kyc-footer-text">
                  Certified and Valid IDs of the Directors / Authorised
                  signatories / Beneficial Owners / Controlling Persons (
                  <span style={{ color: "#e23636" }}>
                    {t("kyc.certifiedTrueCopy")}
                  </span>
                  )
                </p>
                <p className="verify-kyc-footer-text">
                  ({" "}
                  <span style={{ color: "#3f25ae" }}>
                    Supports multiple documents
                  </span>
                  )
                </p>

                <div className="profile-edit-contact-body">
                  <UploadDocumentOverlayMultiple
                    fileTypes="image/jpg,image/jpeg,image/png,image/heic,image/webp,application/pdf"
                    fileTypesText="JPG, PNG, HEIC, WEBP or PDF (max 50 MB)"
                    metadataName={props?.applicantName || userAddress}
                    uploadedDocuments={uploadedDocumentIdOfDirectors}
                    setUploadedDocuments={setUploadedDocumentIdOfDirectors}
                    uploadedDocumentsHash={uploadedDocumentHashIdOfDirectors}
                    setUploadedDocumentsHash={
                      setUploadedDocumentHashIdOfDirectors
                    }
                    uploadPercentages={uploadPercentageIdOfDirectors}
                    setUploadPercentages={setUploadPercentageIdOfDirectors}
                    inputTagId="idOfDirectors-input-tag"
                    inputTagIdSec="idOfDirectors-input-tag-sec"
                    hashKycName="uploadedDocumentIdOfDirectors"
                    docKycName="uploadedDocumentIdOfDirectorsDt"
                    setKycQuestionaire={_setKycQuestionaire}
                    kycQuestionaireGen={props.KYCQuestionnaire}
                    isMulitple={true}
                  />
                </div>

                <p className="verify-kyc-footer-text">
                  {t("kyc.fatcaCrsSelfCertification")}
                </p>
                <p
                  style={{
                    fontWeight: "300",
                    display: "flex",
                    gap: "8px",
                    flexDirection: "column",
                    maxWidth: "300px",
                  }}
                  className="select-bank-popup-body-content-text"
                >
                  <span className="select-bank-popup-body-content-text">
                    {t("kyc.fillAndUpload")}
                  </span>

                  <a
                    style={{ color: "blue", cursor: "pointer" }}
                    target="_blank"
                    rel="noreferrer"
                    href="https://verified-kyc.s3.amazonaws.com/FATCA-CRS-Self-Certification+form+for+Controlling+Person.docx"
                    className="select-bank-popup-body-content-text"
                  >
                    {t("kyc.downloadFatcaCrsForm")}
                  </a>
                </p>
                <div className="profile-edit-contact-body">
                  <UploadDocumentOverlay
                    fileTypes="image/jpg,image/jpeg,image/png,image/heic,image/webp,application/pdf"
                    fileTypesText="JPG, PNG, HEIC, WEBP or PDF (max 50 MB)"
                    metadataName={props?.applicantName || userAddress}
                    uploadedDocument={uploadedDocumentFATCACRS}
                    setUploadedDocument={setUploadedDocumentFATCACRS}
                    uploadedDocumentHash={uploadedDocumentHashFATCACRS}
                    setUploadedDocumentHash={setUploadedDocumentHashFATCACRS}
                    uploadPercentage={uploadPercentageFATCACRS}
                    setUploadPercentage={setUploadPercentageFATCACRS}
                    inputTagId="fatcaCrs-input-tag"
                    inputTagIdSec="fatcaCrs-input-tag-sec"
                    hashKycName="uploadedDocumentFATCACRS"
                    docKycName="uploadedDocumentFATCACRSDt"
                    setKycQuestionaire={_setKycQuestionaire}
                    kycQuestionaireGen={props.KYCQuestionnaire}
                  />
                </div>

                {selectedUserType === "Institutional Investor" && (
                  <React.Fragment>
                    <p className="verify-kyc-footer-text">
                      {t("kyc.amlPolicyAndProcedures")}
                    </p>

                    <div className="profile-edit-contact-body">
                      <UploadDocumentOverlay
                        fileTypes="image/jpg,image/jpeg,image/png,image/heic,image/webp,application/pdf"
                        fileTypesText="JPG, PNG, HEIC, WEBP or PDF (max 50 MB)"
                        metadataName={props?.applicantName || userAddress}
                        uploadedDocument={uploadedDocumentAMLPolicy}
                        setUploadedDocument={setUploadedDocumentAMLPolicy}
                        uploadedDocumentHash={uploadedDocumentHashAMLPolicy}
                        setUploadedDocumentHash={
                          setUploadedDocumentHashAMLPolicy
                        }
                        uploadPercentage={uploadPercentageAMLPolicy}
                        setUploadPercentage={setUploadPercentageAMLPolicy}
                        inputTagId="amlPolicy-input-tag"
                        inputTagIdSec="amlPolicy-input-tag-sec"
                        hashKycName="uploadedDocumentAMLPolicy"
                        docKycName="uploadedDocumentAMLPolicyDt"
                        setKycQuestionaire={_setKycQuestionaire}
                        kycQuestionaireGen={props.KYCQuestionnaire}
                      />
                    </div>
                  </React.Fragment>
                )}

                <p className="verify-kyc-footer-text">
                  {t("kyc.latestAuditedAnnualReport")}
                </p>
                <p
                  style={{
                    fontWeight: "300",
                    display: "flex",
                    gap: "8px",
                    flexDirection: "column",
                    maxWidth: "300px",
                  }}
                  className="select-bank-popup-body-content-text"
                >
                  <span className="select-bank-popup-body-content-text">
                    {t("kyc.auditedReportUploadInstruction")}
                  </span>

                  <span className="select-bank-popup-body-content-text">
                    {t("kyc.or")}
                  </span>

                  <span className="select-bank-popup-body-content-text">
                    {t("kyc.nonAvailabilityDeclaration")}
                  </span>
                </p>
                <div className="profile-edit-contact-body">
                  <UploadDocumentOverlay
                    fileTypes="image/jpg,image/jpeg,image/png,image/heic,image/webp,application/pdf"
                    fileTypesText="JPG, PNG, HEIC, WEBP or PDF (max 50 MB)"
                    metadataName={props?.applicantName || userAddress}
                    uploadedDocument={uploadedDocumentAnnualReport}
                    setUploadedDocument={setUploadedDocumentAnnualReport}
                    uploadedDocumentHash={uploadedDocumentHashAnnualReport}
                    setUploadedDocumentHash={
                      setUploadedDocumentHashAnnualReport
                    }
                    uploadPercentage={uploadPercentageAnnualReport}
                    setUploadPercentage={setUploadPercentageAnnualReport}
                    inputTagId="annualReport-input-tag"
                    inputTagIdSec="annualReport-input-tag-sec"
                    hashKycName="uploadedDocumentAnnualReport"
                    docKycName="uploadedDocumentAnnualReportDt"
                    setKycQuestionaire={_setKycQuestionaire}
                    kycQuestionaireGen={props.KYCQuestionnaire}
                  />
                </div>

                <p
                  style={{ color: "#e23636" }}
                  className="verify-kyc-footer-text"
                >
                  Add up to FOUR DIGITAL WALLETS for your organization along
                  with designation of the authorized officer using each wallet.
                  All wallets should have a transaction history
                </p>

                <p className="verify-kyc-footer-text">
                  {t("kyc.firstWalletAndOfficer")}
                </p>

                <div className="profile-edit-contact-body">
                  <input
                    name="first-wallet-input"
                    style={{
                      border: "1px solid var(--Neutral-100, #eeeef0)",
                      background: "transparent",
                      fontWeight: "600",
                    }}
                    value={inputWallet1}
                    onInput={async (e) => {
                      setInputWallet1(e.target.value);
                      let kycQuestionaireLc =
                        JSON.parse(
                          localStorage.getItem(
                            `${userAddress?.toLowerCase()}-kyc-aml`,
                          ),
                        ) || {};
                      kycQuestionaireLc["inputWallet1"] =
                        await encryptKycString(e.target.value);

                      _setKycQuestionaire((prev) => ({
                        ...prev,
                        inputWallet1: e.target.value,
                      }));
                      localStorage.setItem(
                        `${userAddress?.toLowerCase()}-kyc-aml`,
                        JSON.stringify({
                          ...kycQuestionaireLc,
                          lastUpdated: Date.now(),
                        }),
                      );
                    }}
                    type="text"
                    className="offer-security-popup-input"
                    placeholder={t("placeholder.walletAddress")}
                  />
                </div>

                <p className="verify-kyc-footer-text">
                  {t("kyc.secondWalletAndOfficer")}
                </p>

                <div className="profile-edit-contact-body">
                  <input
                    name="second-wallet-input"
                    style={{
                      border: "1px solid var(--Neutral-100, #eeeef0)",
                      background: "transparent",
                      fontWeight: "600",
                    }}
                    value={inputWallet2}
                    onInput={async (e) => {
                      setInputWallet2(e.target.value);
                      let kycQuestionaireLc =
                        JSON.parse(
                          localStorage.getItem(
                            `${userAddress?.toLowerCase()}-kyc-aml`,
                          ),
                        ) || {};
                      kycQuestionaireLc["inputWallet2"] =
                        await encryptKycString(e.target.value);

                      _setKycQuestionaire((prev) => ({
                        ...prev,
                        inputWallet2: e.target.value,
                      }));
                      localStorage.setItem(
                        `${userAddress?.toLowerCase()}-kyc-aml`,
                        JSON.stringify({
                          ...kycQuestionaireLc,
                          lastUpdated: Date.now(),
                        }),
                      );
                    }}
                    type="text"
                    className="offer-security-popup-input"
                    placeholder={t("placeholder.walletAddress")}
                  />
                </div>

                <p className="verify-kyc-footer-text">
                  {t("kyc.thirdWalletAndOfficer")}
                </p>

                <div className="profile-edit-contact-body">
                  <input
                    name="third-wallet-input"
                    style={{
                      border: "1px solid var(--Neutral-100, #eeeef0)",
                      background: "transparent",
                      fontWeight: "600",
                    }}
                    value={inputWallet3}
                    onInput={async (e) => {
                      setInputWallet3(e.target.value);
                      let kycQuestionaireLc =
                        JSON.parse(
                          localStorage.getItem(
                            `${userAddress?.toLowerCase()}-kyc-aml`,
                          ),
                        ) || {};
                      kycQuestionaireLc["inputWallet3"] =
                        await encryptKycString(e.target.value);

                      _setKycQuestionaire((prev) => ({
                        ...prev,
                        inputWallet3: e.target.value,
                      }));
                      localStorage.setItem(
                        `${userAddress?.toLowerCase()}-kyc-aml`,
                        JSON.stringify({
                          ...kycQuestionaireLc,
                          lastUpdated: Date.now(),
                        }),
                      );
                    }}
                    type="text"
                    className="offer-security-popup-input"
                    placeholder={t("placeholder.walletAddress")}
                  />
                </div>

                <p className="verify-kyc-footer-text">
                  {t("kyc.fourthWalletAndOfficer")}{" "}
                </p>

                <div className="profile-edit-contact-body">
                  <input
                    name="third-wallet-input"
                    style={{
                      border: "1px solid var(--Neutral-100, #eeeef0)",
                      background: "transparent",
                      fontWeight: "600",
                    }}
                    value={inputWallet4}
                    onInput={async (e) => {
                      setInputWallet4(e.target.value);
                      let kycQuestionaireLc =
                        JSON.parse(
                          localStorage.getItem(
                            `${userAddress?.toLowerCase()}-kyc-aml`,
                          ),
                        ) || {};
                      kycQuestionaireLc["inputWallet4"] =
                        await encryptKycString(e.target.value);

                      _setKycQuestionaire((prev) => ({
                        ...prev,
                        inputWallet4: e.target.value,
                      }));
                      localStorage.setItem(
                        `${userAddress?.toLowerCase()}-kyc-aml`,
                        JSON.stringify({
                          ...kycQuestionaireLc,
                          lastUpdated: Date.now(),
                        }),
                      );
                    }}
                    type="text"
                    className="offer-security-popup-input"
                    placeholder={t("placeholder.walletAddress")}
                  />
                </div>
              </React.Fragment>
            )}
          </React.Fragment>
        )}
    </React.Fragment>
  );
};

export default QuestionaireOverlay;
